"use client";

import Image from "next/image";
import React from "react";
import Link from "next/link";

interface RelatedCaseStudiesCardProps {
  thumbnailSrc: string;
  company: string;
  description: string;
  path: string;
  logoSrc?: string;
  tags?: string[];
}

const RelatedCaseStudiesCard: React.FC<RelatedCaseStudiesCardProps> = ({
  thumbnailSrc,
  company,
  description,
  path,
  logoSrc,
  
}) => {
  return (
    <Link href={path} className="block group">
      <div className="w-full bg-transparent overflow-hidden transition-all duration-300 hover:scale-[1.02] hover:shadow-xl">
        {/* Top Image */}
        <div className="relative w-full h-[260px] overflow-hidden">
          <Image
            src={thumbnailSrc}
            alt={`${company} case study thumbnail`}
            fill
            className="object-cover transition-transform duration-500 group-hover:scale-110"
            quality={100}
          />
          {/* Overlay effect */}
          <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300"></div>
          
          {/* Logo overlay in top-right corner */}
          {logoSrc && (
            <div className="absolute top-4 right-4 w-12 h-12 bg-white/90 backdrop-blur-sm rounded-lg p-2 shadow-lg">
              <Image
                src={logoSrc}
                alt={`${company} logo`}
                width={32}
                height={32}
                className="w-full h-full object-contain"
              />
            </div>
          )}
        </div>

        {/* Content Card */}
        <div className="m-4">
          <div className="bg-white/80 backdrop-blur-md px-6 py-4 text-[#333] -mt-16 relative z-50 shadow-[0_4px_8px_0_rgba(0,0,0,0.03)] transition-all duration-300 group-hover:bg-white/90 group-hover:shadow-[0_8px_25px_0_rgba(0,0,0,0.1)]">
            {/* Company Title */}
            <h3 className="text-[#272D57] text-xl font-semibold leading-tight mb-2 transition-all duration-300 group-hover:text-[#E0301E]">
              {company}
            </h3>

            {/* Description */}
            <p className="text-[#1b1b1b] leading-relaxed transition-colors duration-300 group-hover:text-[#333] mb-3 line-clamp-2">
              {description}
            </p>

          
          </div>
        </div>
      </div>
    </Link>
  );
};

export default RelatedCaseStudiesCard;
